import { render, staticRenderFns } from "./RecipeLeaf.vue?vue&type=template&id=2c8e9352&"
import script from "./RecipeLeaf.vue?vue&type=script&lang=ts&"
export * from "./RecipeLeaf.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeLeaf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports